export default {
	path: '/add-address/:id',
	meta: {
		title: '新增地址'
	},
	component: r => require.ensure([], () => r(require(`./index.vue`)), `/add-address/:id`),
}



// WEBPACK FOOTER //
// ./src/views/AddAddress/router.js